import React from 'react';
import { motion } from 'framer-motion';
export function WhySection() {
  return <section className="py-32 md:py-40 bg-soft-white" data-id="element-80">
      <div className="max-w-3xl mx-auto px-6 md:px-12 text-center" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-82">
          <span className="text-xs uppercase tracking-[0.2em] text-warm-gray block mb-8" data-id="element-83">
            Why
          </span>

          <p className="font-serif text-2xl md:text-3xl leading-loose md:leading-[1.8] text-charcoal" data-id="element-84">
            We live in a world of constant connection. Every message arrives
            instantly. Every feeling is expressed in shorthand. But somewhere
            along the way, longing disappeared.
            <span className="block mt-8" data-id="element-85">
              Yearn exists to bring it back — not as nostalgia, but as presence.
              A letter that takes days to arrive. Words that were chosen slowly.
              The quiet act of waiting for something beautiful.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}